module.exports = __webpack_public_path__ + "img/Summary.cff49c78.svg";